import React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

const EnglishLanguage = ({ ...props }) => {
  return (
    <Svg
      width={36}
      height={36}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={36} height={36} rx={18} fill="#fff" />
      <Path
        d="M13.499 21.353c.084.177.126.35.126.518 0 .308-.126.57-.378.784a1.23 1.23 0 0 1-.84.322c-.215 0-.41-.056-.588-.168a1.134 1.134 0 0 1-.42-.504l-.63-1.414H6.233l-.644 1.414a1.103 1.103 0 0 1-.434.504 1.079 1.079 0 0 1-.588.168c-.318 0-.607-.107-.868-.322-.252-.215-.378-.476-.378-.784 0-.168.042-.34.126-.518l3.696-7.588a1.27 1.27 0 0 1 .532-.574c.242-.14.508-.21.798-.21.28 0 .541.07.784.21.242.13.424.322.546.574l3.696 7.588ZM9.9 18.959l-1.4-3.122-1.4 3.122h2.8Z"
        fill="#389CFF"
      />
      <Path
        d="M21.321 17.811c.579.177 1.022.476 1.33.896.308.41.462.92.462 1.526 0 .541-.145 1.017-.434 1.428-.28.401-.686.714-1.218.938-.522.224-1.138.336-1.848.336H15.89c-.382 0-.676-.103-.882-.308-.205-.205-.308-.5-.308-.882v-7.49c0-.383.103-.677.308-.882.206-.205.5-.308.882-.308h3.584c1.036 0 1.858.233 2.464.7.616.457.924 1.078.924 1.862 0 .504-.135.952-.406 1.344-.27.383-.648.663-1.134.84Zm-4.116-.868h1.834c.485 0 .84-.075 1.064-.224.224-.15.336-.387.336-.714 0-.345-.112-.597-.336-.756-.224-.159-.579-.238-1.064-.238h-1.834v1.932Zm2.086 4.046c.514 0 .878-.08 1.092-.238.224-.168.336-.439.336-.812 0-.373-.112-.64-.336-.798-.214-.168-.578-.252-1.092-.252h-2.086v2.1h2.086Z"
        fill="#AFD7FF"
      />
      <Path
        d="M29.11 23.061c-.99 0-1.858-.205-2.604-.616a4.297 4.297 0 0 1-1.722-1.764c-.402-.765-.602-1.661-.602-2.688 0-1.017.2-1.909.602-2.674a4.295 4.295 0 0 1 1.722-1.764c.746-.41 1.614-.616 2.604-.616 1.185 0 2.226.313 3.122.938.158.112.27.233.336.364.074.13.112.299.112.504 0 .29-.084.537-.252.742a.73.73 0 0 1-.588.294c-.14 0-.266-.019-.378-.056a2.79 2.79 0 0 1-.392-.21 3.973 3.973 0 0 0-.924-.42 3.198 3.198 0 0 0-.896-.126c-.831 0-1.452.252-1.862.756-.402.495-.602 1.25-.602 2.268 0 1.027.2 1.792.602 2.296.41.495 1.03.742 1.862.742.28 0 .55-.042.812-.126a13.72 13.72 0 0 0 1.008-.42c.196-.103.34-.173.434-.21a.903.903 0 0 1 .336-.056c.233 0 .429.103.588.308.168.196.252.439.252.728 0 .196-.038.364-.112.504-.066.13-.178.252-.336.364-.896.625-1.937.938-3.122.938Z"
        fill="#7EBFFF"
      />
    </Svg>
  )
}

export default EnglishLanguage
